import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { PermissionErrorToast } from '@core/services/permission-error-toast';

/**
 * Surfaces an "access denied" toast on any 401/403 from an API call, in one global place — no per-service wiring.
 * A 401 is NOT treated as a dead session; real session loss is handled by the OIDC `SilentRenewFailed` event
 * (see SessionExpiryService). The toast service decides whether the error qualifies, so this forwards every error.
 */
export function permissionErrorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const permissionToast = inject(PermissionErrorToast);

  return next(req).pipe(
    catchError((error) => {
      permissionToast.notifyIfAccessDenied(error);
      return throwError(() => error);
    })
  );
}
